import React, {useRef, useState} from "react";
import {Modal, Button, Spin, message} from "antd";
import {addCustomerAsset} from "../../apiService/RESTApi";
import {PaperClipOutlined} from "@ant-design/icons";
import {copyToClipboard} from "../../utility/clipboard";

export default function UploadAsset({ customerUuid, open, onCancel, onUploaded }) {
    const fileInputRef = useRef(null);
    const [fileSelected, setFileSelected] = useState(false);
    const [loading, setLoading] = useState(false);

    const [uploadedAsset, setUploadedAsset] = useState(null);

    const handleFileChange = () => {
        setFileSelected(fileInputRef.current.files.length > 0);
    };

    const handleImageUpload = async () => {
        const file = fileInputRef.current.files[0];
        if (!file) return;

        setLoading(true);
        try {
            const asset = await addCustomerAsset(customerUuid, file);
            message.success("Upload successful");
            onUploaded(asset);
            fileInputRef.current.value = "";
            setFileSelected(false);
        } catch (err) {
            message.error("Upload failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            onRequestClose={onCancel}
            contentLabel="Upload Image"
            className="modal"
            overlayClassName="overlay"
            okText="Done"
            cancelButtonProps={{style: {display: 'none'}}}
            onOk={() => {
                fileInputRef.current.value = '';
                setUploadedAsset(null);
                setLoading(false);
                setFileSelected(false);
                onCancel()
            }}
        >
            <h2>Upload Assets</h2>
            <input type="file" accept="image/*" ref={fileInputRef} onChange={handleFileChange} disabled={loading}/>
            {fileSelected && <button onClick={handleImageUpload} disabled={loading}>Upload</button>}
            {loading && <Spin style={{marginLeft: 10}}/>}
            {uploadedAsset && (
                <div className="uploaded-asset">
                    <span className="asset-url">{uploadedAsset.name}</span>
                    <Button onClick={() => copyToClipboard(uploadedAsset.url)} className="copy-button">
                        <PaperClipOutlined/>
                    </Button>
                </div>
            )}
        </Modal>
    );
}